
export default {
  name: 'news-list',
  props: {
    list: {
      type:Array,
      default: () => ([]),
    },
  },
  computed: {
    slicedNews() {
      return this.list.slice(0, 5);
    },
  },
};
